import React, { useState, useEffect } from "react";
import { Container, Grid, Card, Typography, Box } from "@mui/material";
import { NavLink, useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import DailyTestIcon from "../../asserts/calendar_3483602.jpg";
import MiniTestIcon from "../../asserts/checklist_3534135.jpg";
import MicroIcon from "../../asserts/exam_8980068.jpg";
import { PageHeader } from "../ui/PageHeaders";

const PageWrapper = styled(Box)(({ theme }) => ({
  minHeight: "100vh",
  padding: "40px 0",
  background: theme.palette.mode === "light"
    ? "linear-gradient(135deg, #F8FAFC 0%, #EFF6FF 100%)"
    : "linear-gradient(135deg, #0B0F19 0%, #111827 100%)",
}));

const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: "20px",
  padding: "24px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  minHeight: "220px",
  cursor: "pointer",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
  height: "100%",
  "&:hover": {
    transform: "translateY(-6px)",
    boxShadow: theme.palette.mode === "light"
      ? "0 12px 24px rgba(30, 58, 138, 0.08)"
      : "0 12px 24px rgba(0, 0, 0, 0.4)",
    borderColor: theme.palette.primary.main,
  },
}));

const ImageContainer = styled(Box)(({ theme }) => ({
  width: "80px",
  height: "80px",
  borderRadius: "18px",
  backgroundColor: theme.palette.mode === "light" ? "#F1F5F9" : "#1F2937",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "16px",
  overflow: "hidden",
  padding: "10px",
  transition: "transform 0.3s ease",
  [`${StyledCard}:hover &`]: {
    transform: "scale(1.08)",
  },
}));

export default function HybridTest() {
  const [remainingTime, setRemainingTime] = useState(calculateRemainingTime());
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setRemainingTime(calculateRemainingTime());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  function calculateRemainingTime() {
    const now = new Date();
    const target = new Date();
    target.setHours(8); // 8:00 AM
    target.setMinutes(55); // 8:55 AM
    target.setSeconds(0); // 0 seconds
    if (now.getHours() > 8 || (now.getHours() === 8 && now.getMinutes() >= 55)) {
      target.setDate(target.getDate() + 1); // Move to tomorrow
    }
    const difference = target - now;
    return difference > 0 ? difference : 0;
  }

  function formatTime(ms) {
    const hours = Math.floor(ms / 3600000);
    const minutes = Math.floor((ms % 3600000) / 60000);
    const seconds = Math.floor((ms % 60000) / 1000);
    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  }

  const datas = [
    {
      img: DailyTestIcon,
      name: "Daily Test",
      path: "/dailyinstruction",
      Time: formatTime(remainingTime),
    },
    {
      img: MiniTestIcon,
      name: "Mini Test",
      path: "/miniinstruction",
    },
    {
      img: MicroIcon,
      name: "Micro Test",
      path: "/microinstruction",
    },
  ];

  return (
    <PageWrapper>
      <Container maxWidth="lg">
        <PageHeader 
          title="Hybrid Test" 
          subtitle="Test your skills daily with standard, mini and micro tests"
          onBack={() => navigate("/home")} 
        />
        <Grid container spacing={3} style={{ marginTop: "8px", justifyContent: "center" }}>
          {datas.map((d, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <NavLink to={d.path} style={{ textDecoration: "none", color: "inherit" }}>
                <StyledCard>
                  <ImageContainer>
                    <img 
                      src={d.img} 
                      alt={d.name} 
                      style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain", borderRadius: "10px" }} 
                    />
                  </ImageContainer>
                  <Typography variant="h3" style={{ fontWeight: 700, fontSize: "1.2rem", marginBottom: d.Time ? "8px" : "0" }}>
                    {d.name}
                  </Typography>
                  {d.Time && (
                    <Typography variant="body2" color="secondary" style={{ fontWeight: 700, letterSpacing: "0.5px" }}>
                      Resets In: {d.Time}
                    </Typography>
                  )}
                </StyledCard>
              </NavLink>
            </Grid>
          ))}
        </Grid>
      </Container>
    </PageWrapper>
  );
}
